import Section from '~/components/flp/Section';
import { appAssetsCdnUrl } from '~/constants/environment';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { useFinancingContext } from '~/context/flp/FinancingContext';
import {
  Container,
  Gradient,
  Heading,
  HeroSection,
  Wrapper
} from './Hero.styles';
import { TermsCard } from './TermsCard';

export default function Hero() {
  const { applicant } = useFinancingContext();

  const inlineStyles = {
    '--gradient-bg-image-mobile': `url('${appAssetsCdnUrl}/images/flp/new-finance-gradient-mobile.svg')`,
    '--gradient-bg-image': `url('${appAssetsCdnUrl}/images/flp/new-finance-gradient.svg')`
  } as React.CSSProperties;

  return (
    <Section
      as={HeroSection}
      eventName={ANALYTICS_EVENTS.PREQUALIFIED.SECTION_VIEWED_HERO}
      style={inlineStyles}
    >
      <Gradient />
      <Wrapper>
        <Container>
          <Heading>{applicant?.firstName}, you’re pre&#8209;qualified!</Heading>
          <TermsCard />
        </Container>
      </Wrapper>
    </Section>
  );
}
